export default __webpack_public_path__ + "static/media/factura6.8e1c8a29.pdf";